import React from 'react';
import ReactDOM from 'react-dom';
import { CookiesProvider } from 'react-cookie'; 

import './index.css';

import App from './App';

//redux module
import { Provider } from 'react-redux';
import store from './app/store';

ReactDOM.render(
  <React.StrictMode>
    <CookiesProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </CookiesProvider>
  </React.StrictMode>,
  document.getElementById('root')
);